export default __webpack_public_path__ + "static/tr-bd82f8b70598f545627161ba111097df.svg";